import { createContext } from 'react';
import type { OrganizationContract } from '@raas/shared/src/features/organization/contracts/organization.type';

export interface OrganizationDataContextContract {
  organizations: OrganizationContract[] | null;
  setOrganizations: (organizations: OrganizationContract[] | null) => void;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
}

const OrganizationDataContext = createContext<OrganizationDataContextContract | undefined>(
  undefined
);

export default OrganizationDataContext;
